<template>
  <widget-wrapper
    :id="''"
    title=""
    :defaultTitle="chartAttr.title"
    :subTitle="''"
    :addtxt="''"
    :info="''"
    :empty="empty"
    :loading="loadingbar"
    @ctrl="ctrlClick"
    class="custom1 title-box-widget"
  >
    <div v-if="chartAttr.title" class="widget-desc">
      <div class="widget-desc-name">{{ chartAttr.title }}</div>
    </div>
  </widget-wrapper>
</template>
<script>
import widgetWrapper from '@/components/scpm/widgets/common/widgetWrapperScpm';
import widgetMixin from './widgetMixin';
export default {
  name: 'widgetDesc',
  components: { widgetWrapper },
  mixins: [widgetMixin],
  methods: {
    getData() {}
  },
  props: {
    configItem: {
      type: Object
    }
  },
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">

.widget-desc {
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  @include font(16px);
  flex-direction: column;
  white-space: pre-wrap;
  word-wrap: break-word;
  color: $color--ui01;
  text-align: center;
  // margin-right: 10px;
  word-break: break-all;
}
.widget-desc-name {
  width: 100%;
}
.title-box-widget {
  overflow: visible !important;
}
</style>
